import { Card, Grid } from "@mui/material";
import { MealItemProgressRequest } from "../../../../service/model/nutrition.model";
import theme from "../../../../app/app-theme";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { selectNutritionPlanDay, updateMealItemProgress } from "../nutrition-plan.slice";
import NutritionSumChip from "./nutrition-sum-chip";
import NutritionMemberViewTable from "./nutrition-member-view-table";

interface TodayNutritionPlanProps {
    nutritionPlanId: number;
    day: string;
}

const NutritionPlanDayMemberView = ({ nutritionPlanId, day }: TodayNutritionPlanProps) => {
    const dispatch = useAppDispatch();
    const nutritionPlanDay = useAppSelector(selectNutritionPlanDay)

    const handleSelect = (mealIndex: number, mealItemIndex: number, mealItemId: number, checked: boolean) => {
        const request: MealItemProgressRequest = {
            nutritionPlanId: nutritionPlanId,
            progressDate: day,
            planDay: nutritionPlanDay?.planDay ?? 0,
            mealIndex: mealIndex,
            mealItemIndex: mealItemIndex,
            mealItemId: mealItemId,
            completed: checked,
        };
        dispatch(updateMealItemProgress(request));
    }

    return (
        <>
            {nutritionPlanDay ? (
                <>
                    <div>
                        <Grid container justifyContent="center" spacing={1} sx={{ mb: 2, mt: 2 }}>
                            <NutritionSumChip nutrition="Calories" consumed={nutritionPlanDay?.consumedNutrition.calories} planned={nutritionPlanDay?.plannedNutrition?.calories} />
                            <NutritionSumChip nutrition="Protein" consumed={nutritionPlanDay?.consumedNutrition.protein} planned={nutritionPlanDay?.plannedNutrition?.protein} />
                            <NutritionSumChip nutrition="Carbs" consumed={nutritionPlanDay?.consumedNutrition.carbohydrates} planned={nutritionPlanDay?.plannedNutrition?.carbohydrates} />
                            <NutritionSumChip nutrition="Fat" consumed={nutritionPlanDay?.consumedNutrition.fat} planned={nutritionPlanDay?.plannedNutrition?.fat} />
                            <NutritionSumChip nutrition="Fiber" consumed={nutritionPlanDay?.consumedNutrition.fiber} planned={nutritionPlanDay?.plannedNutrition?.fiber} />
                            <NutritionSumChip nutrition="Sugar" consumed={nutritionPlanDay?.consumedNutrition.sugar} planned={nutritionPlanDay?.plannedNutrition?.sugar} />
                        </Grid>
                    </div>
                    <Grid container direction="row" justifyContent="flex-start" spacing={2}>
                        {nutritionPlanDay.meals.map((meal, index) => (
                            <Grid size={{ xs: 12 }} sx={{ display: "flex", flexDirection: "column" }} key={index}>
                                <Card key={index} style={{ marginTop: "12px", padding: 12, backgroundColor: theme.palette.primary.contrastText, overflowY: "auto", height: "100%" }}>
                                    <NutritionMemberViewTable meal={meal} day={day} handleSelect={handleSelect} />
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </>
            ) : (
                <p>No nutrition plan available for today.</p>
            )}
        </>
    );
}

export default NutritionPlanDayMemberView;